(function() {
  'use strict';
  
  // Маппинг английских изображений на испанские
 const imageMapping = {
  'cotton-fabric-type-infographic-en-1.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/cotton-infographic-latam-es-1.webp?v=1761310520',
  'micromodal-fabric-type-infographic-en-2.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/micrimodal-infographic-latam-es-2.webp?v=1761298329',
  'cooltech-fabric-type-infographic-en-3.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/cooltech-infographic-latam-es-3.webp?v=1761310533',
  'tencel-fabric-type-infographic-en-4.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/tencel-infographic-latam-es-4.webp?v=1760713046',
  'horizontal-fly-pocket-type-infographic-en-5.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/horizontal-fly-infographic-latam-es-5.webp?v=1761310677',
  'diagonal-fly-pocket-type-infographic-en-6.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/diagonal-fly-infographic-latam-es-6.webp?v=1761310687',
  'closed-pocket-type-infographic-en-7.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/closed-pouch-infographic-latam-es-7.webp?v=1761310696',
  'new-infografika-en-8.jpg': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/3d-info-infographic-latam-es-8.webp?v=1761310508',
  'premium-fabric-infographic-en-9.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/premium-fabric-infographic-es-9.webp?v=1761311401',
  'engineered-for-movement-infographic-en-10.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/engineered-for-movement-infographic-es-10.webp?v=1761311520',
  'anatomical-pouch-infographic-en-11.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/anatomical-pouch-infographic-es-11.webp?v=1761311705',
  'anatomical-pack-main-banner-en-12.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/anatomical-pack-main-banner-es-12.webp?v=1761311711',
  'halloween-category-main-banner-en-13.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/halloween-category-main-banner-es-13.webp?v=1761311830',
  'halloween-category-main-banner-mobile-en-14.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/halloween-category-main-banner-mobile-es-14.webp?v=1761311918',
  'sport-category-main-banner-en-15.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/sport-category-main-banner-es-15.webp?v=1761312014',
  'sport-category-main-banner-mobile-en-16.webp': 'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/sport-category-main-banner-mobile-es-16.webp?v=1761312069'
};


  // Прямой маппинг полных URL для более точного сопоставления
 const urlMapping = {
  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/cotton-fabric-type-infographic-en-1.webp?v=1760712776':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/cotton-infographic-latam-es-1.webp?v=1761310520',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/micromodal-fabric-type-infographic-en-2.webp?v=1760712970':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/micrimodal-infographic-latam-es-2.webp?v=1761298329',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/cooltech-fabric-type-infographic-en-3.webp?v=1760712954':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/cooltech-infographic-latam-es-3.webp?v=1761310533',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/tencel-fabric-type-infographic-en-4.webp?v=1760713039':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/tencel-infographic-latam-es-4.webp?v=1760713046',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/horizontal-fly-pocket-type-infographic-en-5.webp?v=1760713067':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/horizontal-fly-infographic-latam-es-5.webp?v=1761310677',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/diagonal-fly-pocket-type-infographic-en-6.webp?v=1760713118':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/diagonal-fly-infographic-latam-es-6.webp?v=1761310687',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/closed-pocket-type-infographic-en-7.webp?v=1760713163':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/closed-pouch-infographic-latam-es-7.webp?v=1761310696',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/products/new-infografika-en-8.jpg?v=1760967509':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/3d-info-infographic-latam-es-8.webp?v=1761310508',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/premium-fabric-infographic-en-9.webp?v=1761311319':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/premium-fabric-infographic-es-9.webp?v=1761311401',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/engineered-for-movement-infographic-en-10.webp?v=1761311503':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/engineered-for-movement-infographic-es-10.webp?v=1761311520',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/anatomical-pouch-infographic-en-11.webp?v=1761311747':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/anatomical-pouch-infographic-es-11.webp?v=1761311705',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/anatomical-pack-main-banner-en-12.webp?v=1761311665':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/anatomical-pack-main-banner-es-12.webp?v=1761311711',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/halloween-category-main-banner-en-13.webp?v=1761311792':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/halloween-category-main-banner-es-13.webp?v=1761311830',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/halloween-category-main-banner-mobile-en-14.webp?v=1761311864':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/halloween-category-main-banner-mobile-es-14.webp?v=1761311918',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/sport-category-main-banner-en-15.webp?v=1761311981':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/sport-category-main-banner-es-15.webp?v=1761312014',

  'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/sport-category-main-banner-mobile-en-16.webp?v=1761312039':
    'https://cdn.shopify.com/s/files/1/0267/6460/7662/files/sport-category-main-banner-mobile-es-16.webp?v=1761312069'
};


  // Переменная для отслеживания состояния обработки
  let isProcessing = false;
  let processedImages = new WeakSet();

  // Функция для проверки, нужно ли показывать испанские изображения
  function shouldShowSpanishImages() {
    // Проверка языка сайта через различные методы
    const htmlLang = document.documentElement.lang;
    const shopifyLocale = window.Shopify?.locale;
    const pathLocale = window.location.pathname.split('/')[1];
    
    console.log('[LocaleImages] Checking locale:', {
      htmlLang: htmlLang,
      shopifyLocale: shopifyLocale,
      pathLocale: pathLocale,
      pathname: window.location.pathname
    });

    // Проверяем различные способы определения испанского языка
    if (htmlLang && (htmlLang.toLowerCase().includes('es') || htmlLang.toLowerCase().includes('spanish'))) {
      console.log('[LocaleImages] Spanish detected via HTML lang');
      return true;
    }
    
    if (shopifyLocale && (shopifyLocale.toLowerCase().includes('es') || shopifyLocale.toLowerCase().includes('spanish'))) {
      console.log('[LocaleImages] Spanish detected via Shopify locale');
      return true;
    }
    
    // Проверка URL path для мультиязычности
    if (pathLocale && (pathLocale === 'es' || pathLocale === 'es-es' || pathLocale === 'es-cl')) {
      console.log('[LocaleImages] Spanish detected via URL path');
      return true;
    }

    // НЕ используем геолокацию для автоматической смены языка
    // Закомментировано для избежания конфликтов
    /*
    const userCountry = window.Shopify?.country || localStorage.getItem('user_country');
    if (userCountry && ['CL', 'ES', 'Chile', 'Spain'].includes(userCountry)) {
      console.log('[LocaleImages] Spanish location detected:', userCountry);
      return true;
    }
    */

    return false;
  }

  // Функция для получения испанского URL изображения
  function getSpanishImageUrl(imageUrl) {
    if (!imageUrl) return null;
    
    // Убираем параметры версии для сравнения
    const cleanUrl = imageUrl.split('?')[0];
    
    // Проверяем прямое соответствие URL
    for (let [enUrl, esUrl] of Object.entries(urlMapping)) {
      if (cleanUrl === enUrl.split('?')[0]) {
        console.log('[LocaleImages] Found direct URL match:', cleanUrl, '->', esUrl);
        return esUrl;
      }
    }
    
    // Проверяем по имени файла
    const urlParts = cleanUrl.split('/');
    const fileName = urlParts[urlParts.length - 1];
    
    if (imageMapping[fileName]) {
      console.log('[LocaleImages] Found filename match:', fileName, '->', imageMapping[fileName]);
      return imageMapping[fileName];
    }
    
    // Проверяем по паттернам в URL
    const patterns = ['-en-1', '-en-2', '-en-3', '-en-4', '-en-5', '-en-6', '-en-7', '-en-8'];
    for (let pattern of patterns) {
      if (cleanUrl.includes(pattern)) {
        // Находим соответствующий испанский URL
        for (let [enUrl, esUrl] of Object.entries(urlMapping)) {
          if (enUrl.includes(pattern)) {
            console.log('[LocaleImages] Found pattern match:', pattern, '->', esUrl);
            return esUrl;
          }
        }
      }
    }
    
    return null;
  }

  // Функция для безопасной замены изображения
  function safeReplaceImage(img, spanishUrl) {
    if (!img || !spanishUrl) return false;
    
    // Проверяем, не обработано ли изображение уже
    if (processedImages.has(img)) {
      console.log('[LocaleImages] Image already processed, skipping');
      return false;
    }
    
    try {
      // Сохраняем оригинальные значения
      if (!img.dataset.originalSrc) {
        img.dataset.originalSrc = img.src || img.dataset.src || '';
        img.dataset.originalSrcset = img.srcset || img.dataset.srcset || '';
      }
      
      // Заменяем src
      if (img.src) {
        img.src = spanishUrl;
      }
      
      // Заменяем srcset
      if (img.srcset) {
        img.srcset = spanishUrl;
      }
      
      // Заменяем data-src (для lazy loading)
      if (img.dataset.src) {
        img.dataset.src = spanishUrl;
      }
      if (img.hasAttribute('data-src')) {
        img.setAttribute('data-src', spanishUrl);
      }
      
      // Заменяем data-srcset
      if (img.dataset.srcset) {
        img.dataset.srcset = spanishUrl;
      }
      
      // Помечаем как обработанное
      img.classList.add('locale-switched-image');
      processedImages.add(img);
      
      return true;
    } catch (error) {
      console.error('[LocaleImages] Error replacing image:', error);
      return false;
    }
  }

  // Функция для замены изображений
  function replaceInfographics() {
    // Проверяем, нужно ли заменять изображения
    const shouldReplace = shouldShowSpanishImages();
    console.log('[LocaleImages] Should replace images:', shouldReplace);
    
    if (!shouldReplace) {
      // Если не нужно заменять, восстанавливаем оригиналы
      restoreOriginalImages();
      return;
    }
    
    // Защита от повторной обработки
    if (isProcessing) {
      console.log('[LocaleImages] Already processing, skipping');
      return;
    }
    
    // Проверяем флаг полной обработки
    if (document.body.dataset.imagesFullyProcessed === 'true') {
      console.log('[LocaleImages] Images fully processed, skipping bulk replacement');
      return;
    }
    
    isProcessing = true;

    // Добавляем класс для CSS защиты
    document.body.classList.add('locale-images-spanish');

    // Расширенный список селекторов для поиска изображений
    const imageSelectors = [
      '.m-product-media--wrapper img',
      '.m-media-gallery__list img',
      '.m-product-media--item img',
      '.product__media img',
      '.product-single__media img',
      '.product-media-container img',
      '.product__main-photos img',
      '.product-gallery img',
      '[data-product-single-media-wrapper] img',
      '.product-image-main img',
      '.product__photos img',
      '.product-photo-container img',
      '.product__photo img',
      '.media img',
      '.product-media img',
      '[data-media-id] img',
      '.product-single__photo img',
      '.slick-slide img',
      '.swiper-slide img',
      '.product-images img',
      '.product-image img'
    ];

    const images = document.querySelectorAll(imageSelectors.join(', '));
    console.log('[LocaleImages] Found images:', images.length);

    let replacedCount = 0;
    images.forEach(img => {
      const currentSrc = img.src || img.dataset.src || img.getAttribute('data-src');
      if (!currentSrc) return;

      const spanishUrl = getSpanishImageUrl(currentSrc);
      if (spanishUrl && safeReplaceImage(img, spanishUrl)) {
        replacedCount++;
      }
    });

    console.log('[LocaleImages] Replaced images count:', replacedCount);

    // Обработка thumbnail изображений
    replaceThumbnails();
    
    // Обработка изображений в модальных окнах
    replaceModalImages();
    
    // Помечаем как полностью обработанное только если заменили все нужные изображения
    if (replacedCount > 0) {
      document.body.dataset.imagesFullyProcessed = 'true';
    }
    
    isProcessing = false;
  }

  // Функция для восстановления оригинальных изображений
  function restoreOriginalImages() {
    console.log('[LocaleImages] Restoring original images');
    
    document.querySelectorAll('.locale-switched-image').forEach(img => {
      if (img.dataset.originalSrc) {
        img.src = img.dataset.originalSrc;
      }
      if (img.dataset.originalSrcset) {
        img.srcset = img.dataset.originalSrcset;
      }
      img.classList.remove('locale-switched-image');
    });
    
    document.querySelectorAll('.locale-switched-thumbnail').forEach(img => {
      if (img.dataset.originalSrc) {
        img.src = img.dataset.originalSrc;
      }
      img.classList.remove('locale-switched-thumbnail');
    });
    
    // Очищаем флаги
    document.body.dataset.imagesFullyProcessed = 'false';
    document.body.classList.remove('locale-images-spanish');
    processedImages = new WeakSet();
  }

  // Функция для замены миниатюр
  function replaceThumbnails() {
    const thumbnailSelectors = [
      '.m-product__thumbs img',
      '.m-product-media__thumb img',
      '.product__thumbs img',
      '.product-single__thumbnails img',
      '.product-thumbnails img',
      '[data-product-single-media-thumbs] img',
      '.thumbnail-list img',
      '.product-single__thumbnail img',
      '.product-thumb img'
    ];

    const thumbnails = document.querySelectorAll(thumbnailSelectors.join(', '));
    console.log('[LocaleImages] Found thumbnails:', thumbnails.length);

    thumbnails.forEach(thumb => {
      const currentSrc = thumb.src || thumb.dataset.src || thumb.getAttribute('data-src');
      if (!currentSrc) return;

      const spanishUrl = getSpanishImageUrl(currentSrc);
      if (spanishUrl) {
        // Сохраняем оригинал
        if (!thumb.dataset.originalSrc) {
          thumb.dataset.originalSrc = currentSrc;
        }
        
        if (thumb.src) thumb.src = spanishUrl;
        if (thumb.dataset.src) thumb.dataset.src = spanishUrl;
        if (thumb.hasAttribute('data-src')) {
          thumb.setAttribute('data-src', spanishUrl);
        }
        thumb.classList.add('locale-switched-thumbnail');
      }
    });
  }

  // Функция для замены изображений в модальных окнах
  function replaceModalImages() {
    const modalSelectors = [
      '.modal img',
      '.pswp__img',
      '.mfp-img',
      '.photoswipe__image img',
      '.product-modal img'
    ];

    const modalImages = document.querySelectorAll(modalSelectors.join(', '));
    modalImages.forEach(img => {
      const currentSrc = img.src || img.dataset.src;
      if (!currentSrc) return;

      const spanishUrl = getSpanishImageUrl(currentSrc);
      if (spanishUrl) {
        if (!img.dataset.originalSrc) {
          img.dataset.originalSrc = currentSrc;
        }
        
        if (img.src) img.src = spanishUrl;
        if (img.dataset.src) img.dataset.src = spanishUrl;
      }
    });
  }

  // Улучшенный наблюдатель за изменениями
  function setupObserver() {
    let observerTimeout;
    
    const observer = new MutationObserver(function(mutations) {
      // Дебаунсинг для предотвращения множественных вызовов
      clearTimeout(observerTimeout);
      
      observerTimeout = setTimeout(() => {
        let hasNewImages = false;
        
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1) { // Element node
                if (node.tagName === 'IMG' && !processedImages.has(node)) {
                  hasNewImages = true;
                } else if (node.querySelectorAll) {
                  const imgs = node.querySelectorAll('img');
                  imgs.forEach(img => {
                    if (!processedImages.has(img)) {
                      hasNewImages = true;
                    }
                  });
                }
              }
            });
          } else if (mutation.type === 'attributes' && mutation.target.tagName === 'IMG') {
            // Если изменились атрибуты изображения
            if (!processedImages.has(mutation.target)) {
              hasNewImages = true;
            }
          }
        });
        
        if (hasNewImages && shouldShowSpanishImages()) {
          console.log('[LocaleImages] New images detected, processing...');
          // Сбрасываем флаг полной обработки для новых изображений
          document.body.dataset.imagesFullyProcessed = 'false';
          replaceInfographics();
        }
      }, 200); // Задержка 200мс для группировки изменений
    });

    // Наблюдаем только за релевантными изменениями
    observer.observe(document.body, { 
      childList: true, 
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'data-src', 'srcset', 'data-srcset']
    });
    
    return observer;
  }

  // Функция инициализации
  function init() {
    console.log('[LocaleImages] Initializing...');
    
    // Добавляем защитные стили
    const style = document.createElement('style');
    style.textContent = `
      /* Защита изображений при испанской локали */
      .locale-images-spanish .m-product-media--wrapper img,
      .locale-images-spanish .m-media-gallery__list img {
        visibility: visible !important;
        opacity: 1 !important;
      }
      
      .locale-switched-image,
      .locale-switched-thumbnail {
        visibility: visible !important;
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);
    
    // Первоначальная замена с небольшой задержкой
    setTimeout(() => {
      replaceInfographics();
    }, 1000);

    // Настраиваем наблюдатель
    const observer = setupObserver();
    
    // Очистка при выходе
    window.addEventListener('beforeunload', () => {
      if (observer) {
        observer.disconnect();
      }
    });
  }

  // Инициализация при загрузке страницы
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Небольшая задержка для страниц, уже загруженных
    setTimeout(init, 100);
  }

  // Обработка различных событий Shopify
  document.addEventListener('shopify:section:load', () => {
    console.log('[LocaleImages] Section loaded, checking images...');
    document.body.dataset.imagesFullyProcessed = 'false';
    setTimeout(replaceInfographics, 500);
  });
  
  document.addEventListener('variant:changed', () => {
    console.log('[LocaleImages] Variant changed, checking images...');
    setTimeout(replaceInfographics, 300);
  });
  
  document.addEventListener('product:media:changed', () => {
    console.log('[LocaleImages] Product media changed, checking images...');
    setTimeout(replaceInfographics, 300);
  });
  
  // Дополнительная проверка после полной загрузки
  window.addEventListener('load', () => {
    setTimeout(() => {
      console.log('[LocaleImages] Window loaded, final check...');
      replaceInfographics();
    }, 1500);
  });
  
  // Экспортируем функции для отладки
  window.LocaleImageSwitcher = {
    replaceInfographics: replaceInfographics,
    restoreOriginalImages: restoreOriginalImages,
    shouldShowSpanishImages: shouldShowSpanishImages,
    getSpanishImageUrl: getSpanishImageUrl,
    init: init,
    debug: {
      processedImages: () => processedImages,
      isProcessing: () => isProcessing
    }
  };
})();